import { render, staticRenderFns } from "./SubMerchant.vue?vue&type=template&id=4d4e587d"
import script from "./SubMerchant.vue?vue&type=script&lang=js"
export * from "./SubMerchant.vue?vue&type=script&lang=js"
import style0 from "./SubMerchant.vue?vue&type=style&index=0&id=4d4e587d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports